import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PageLayout, PageContentPreloader } from 'common/components';
import { UserTagsPanelClient } from '../../_components';
import { getPartnershipClientAccounts } from '../../_redux';
import AccountsBlock from '../../../_components/AccountsBlock';

class PartnershipClientAccountsPage extends React.Component {
  constructor(props) {
    super(props);
    props.getPartnershipClientAccounts(props.match.params.id);
  }

  handleAccountClick = id => {
    const { history, match } = this.props;

    const section = match.path.startsWith('/referFriend') ? 'referFriend' : 'partnership';

    history.push(`/${section}/clients/user/${match.params.id}/account/${id}/`);
  };

  render() {
    const { demoAccounts, realAccounts, partnershipClientAccountsIsLoaded, viewClientsUserTags } = this.props;

    return (
      <PageLayout captionSlug="partnershipClientAccounts">
        <PageContentPreloader ready={partnershipClientAccountsIsLoaded}>
          <AccountsBlock
            data={realAccounts}
            captionId="realAccounts"
            noAccCaptionId="noClientRealAccsCreated"
            userIsVerified
            paymentButtons={false}
            onAccountClick={this.handleAccountClick}
          />
          <AccountsBlock
            data={demoAccounts}
            captionId="demoAccounts"
            noAccCaptionId="noClientDemoAccsCreated"
            userIsVerified
            paymentButtons={false}
            onAccountClick={this.handleAccountClick}
          />
          {viewClientsUserTags && <UserTagsPanelClient userId={this.props.match.params.id} />}
        </PageContentPreloader>
      </PageLayout>
    );
  }
}

PartnershipClientAccountsPage.propTypes = {
  demoAccounts: PropTypes.array,
  realAccounts: PropTypes.array,
  getPartnershipClientAccounts: PropTypes.func.isRequired,
  partnershipClientAccountsIsLoaded: PropTypes.bool,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  viewClientsUserTags: PropTypes.bool.isRequired,
};

PartnershipClientAccountsPage.defaultProps = {
  realAccounts: [],
  demoAccounts: [],
  partnershipClientAccountsIsLoaded: false,
};

export default connect(
  state => ({
    demoAccounts: state.client.partnership.partnershipClientAccounts.filter(account => account.isDemo),
    realAccounts: state.client.partnership.partnershipClientAccounts.filter(account => !account.isDemo),
    partnershipClientAccountsIsLoaded: state.client.partnership.partnershipClientAccountsIsLoaded,
    viewClientsUserTags: state.interfaceConfig.partnership.viewClientsUserTags,
  }),
  {
    getPartnershipClientAccounts: clientId => getPartnershipClientAccounts.request(clientId, true),
  }
)(PartnershipClientAccountsPage);
